import { ArrowLeft, ArrowRight, ArrowUpRight, Plus } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
const categories = [{
  label: "SEMUA",
  active: true
}, {
  label: "NASIONAL",
  active: false
}, {
  label: "DAERAH",
  active: false
}, {
  label: "OPINI",
  active: false
}, {
  label: "KEGIATAN",
  active: false
}, {
  label: "KLARIFIKASI",
  active: false
}];
const fallbackPosts = [{
  id: "f1",
  title: "Konsolidasi organisasi di tingkat wilayah provinsi",
  excerpt: "Langkah strategis dalam memperkuat struktur komando dan sinergi antar pengurus di seluruh pelosok daerah untuk kemajuan organisasi.",
  category: "NASIONAL",
  date: "2024.11.03",
  author: "B. SETIAWAN",
  readTime: "6 MENIT BACA",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/konsolidasi_nasional.webp",
  height: "tall"
}, {
  id: "f2",
  title: "Peluncuran program pemberdayaan ekonomi kreatif",
  excerpt: "Inisiatif baru untuk mendukung kemandirian ekonomi anggota melalui pelatihan keterampilan dan akses pasar digital.",
  category: "KEGIATAN",
  date: "2024.10.28",
  author: "S. PRATAMA",
  readTime: "4 MENIT BACA",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/pemberdayaan_ekonomi.png",
  height: "short"
}, {
  id: "f3",
  title: "Studi kasus: Transformasi digital dalam pelayanan publik",
  excerpt: "Bagaimana penerapan sistem digital membantu mempercepat respon terhadap aspirasi masyarakat di tingkat akar rumput.",
  category: "KLARIFIKASI",
  date: "2024.10.21",
  author: "R. HIDAYAT",
  readTime: "8 MENIT BACA",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/transformasi_digital.webp",
  height: "medium"
}, {
  id: "f4",
  title: "Pentingnya menjaga integritas dalam berorganisasi",
  excerpt: "Refleksi mendalam mengenai nilai-nilai dasar dan etika yang harus dijunjung tinggi oleh setiap kader dalam bertugas.",
  category: "OPINI",
  date: "2024.10.15",
  author: "B. SETIAWAN",
  readTime: "5 MENIT BACA",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/integritas_organisasi.png",
  height: "medium"
}, {
  id: "f5",
  title: "Update struktur: Penyesuaian mandat komando wilayah",
  excerpt: "Pembaruan data dan penyesuaian struktur organisasi untuk meningkatkan efektivitas koordinasi di lapangan.",
  category: "DAERAH",
  date: "2024.10.08",
  author: "S. PRATAMA",
  readTime: "3 MENIT BACA",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/struktur_organisasi.png",
  height: "short"
}, {
  id: "f6",
  title: "Aksi sosial kemanusiaan di wilayah terdampak",
  excerpt: "Laporan kegiatan lapangan mengenai bantuan kemanusiaan yang disalurkan oleh unit badan kepada masyarakat yang membutuhkan.",
  category: "KEGIATAN",
  date: "2024.10.01",
  author: "R. HIDAYAT",
  readTime: "7 MENIT BACA",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/aksi_kemanusiaan.png",
  height: "tall"
}];
function JournalGrid() {
  const {
    posts,
    loading,
    error,
    currentPage,
    totalPages,
    hasNext,
    hasPrev,
    nextPage,
    prevPage,
    isRefetching
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[...Array(6)].map((_, i) => <div key={i} data-index={i} className="border border-border bg-card animate-pulse">
            <div className="aspect-[4/5] bg-muted/40" />
            <div className="p-6 space-y-3">
              <div className="h-4 w-3/4 bg-muted/40" />
              <div className="h-3 w-full bg-muted/30" />
              <div className="h-3 w-2/3 bg-muted/30" />
            </div>
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="border border-border p-12 text-center">
        <p className="text-sm text-muted-foreground font-mono">// ERROR_MEMUAT_DATA</p>
      </div>;
  }
  const displayPosts = posts.length > 0 ? posts : fallbackPosts.map(p => ({
    id: p.id,
    title: p.title,
    excerpt: p.excerpt,
    link: "#",
    date: p.date,
    featuredImage: p.image,
    categories: [{
      id: 1,
      name: p.category,
      slug: "",
      taxonomy: "category"
    }],
    author: {
      id: 1,
      name: p.author
    },
    customFields: {
      readTime: p.readTime,
      height: p.height
    }
  }));
  const formatDate = (d?: string) => {
    if (!d) return "";
    try {
      const date = new Date(d);
      if (!isNaN(date.getTime())) {
        return `${date.getFullYear()}.${String(date.getMonth() + 1).padStart(2, "0")}.${String(date.getDate()).padStart(2, "0")}`;
      }
    } catch {}
    return d;
  };
  return <>
      <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6">
        {displayPosts.map((post, i) => {
        const heights = ["aspect-[4/5]", "aspect-[16/10]", "aspect-[4/5]", "aspect-[16/11]", "aspect-[16/10]", "aspect-[4/5]"];
        const aspect = heights[i % heights.length];
        const category = post.categories?.[0]?.name || "BERITA";
        const authorName = typeof post.author === "object" ? post.author?.name : post.author;
        const readTime = (post as any).customFields?.readTime || "5 MENIT BACA";
        return <article key={post.id} data-index={i} className="group break-inside-avoid mb-6 border border-border bg-card hover:border-primary transition-all duration-300 relative overflow-hidden rounded-lg shadow-md">
              <div className="absolute -top-px -left-px z-20 text-primary">
                <Plus className="w-3 h-3" strokeWidth={1.5} />
              </div>
              <div className="absolute -top-px -right-px z-20 text-primary">
                <Plus className="w-3 h-3" strokeWidth={1.5} />
              </div>

              <Link to={post.link || "#"} className="block">
                <div className={`relative ${aspect} overflow-hidden bg-muted`}>
                  {post.featuredImage && <img src={post.featuredImage} alt={post.title} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.03]" />}
                  <div className="absolute top-3 left-3">
                    <Badge variant="default" className="font-mono text-[10px] tracking-wider bg-background/80 text-primary border border-primary/40 backdrop-blur-sm rounded-md">
                      {category.toUpperCase()}
                    </Badge>
                  </div>
                  <div className="absolute top-3 right-3">
                    <span className="font-mono text-[10px] tracking-wider text-foreground bg-background/80 px-2 py-1 backdrop-blur-sm border border-border rounded-md">
                      {formatDate(post.date)}
                    </span>
                  </div>
                </div>

                <div className="p-6">
                  <h3 className="font-default text-[22px] font-medium leading-snug text-foreground group-hover:text-primary transition-colors duration-300">
                    {post.title}
                  </h3>
                  {post.excerpt && <p className="mt-3 text-sm text-muted-foreground leading-relaxed line-clamp-3 font-default">
                      {post.excerpt.replace(/<[^>]*>/g, "")}
                    </p>}

                  <div className="mt-5 pt-4 border-t border-border flex items-center justify-between">
                    <span className="font-mono text-[11px] tracking-wider text-muted-foreground uppercase">
                      {authorName || "ADMIN"} · {readTime}
                    </span>
                    <span className="font-mono text-[11px] tracking-wider text-primary opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center gap-1">
                      <ArrowUpRight className="w-3 h-3" strokeWidth={2} />
                      BACA
                    </span>
                  </div>
                </div>
              </Link>
            </article>;
      })}
      </div>

      {(posts.length > 0 || totalPages > 1) && <div className="mt-16 pt-8 border-t border-border flex items-center justify-between">
          <div className="font-mono text-xs tracking-wider text-muted-foreground">
            <span className="text-primary">{String(currentPage).padStart(2, "0")}</span>
            <span className="mx-2 text-border">/</span>
            <span>{String(Math.max(totalPages, 1)).padStart(2, "0")}</span>
          </div>

          <div className="flex items-center gap-2">
            <Button variant="outline" size="icon" onClick={prevPage} disabled={!hasPrev || isRefetching} className="border-border hover:border-primary hover:text-primary hover:bg-transparent disabled:opacity-30 rounded-md" aria-label="Halaman sebelumnya">
              <ArrowLeft className="w-4 h-4" strokeWidth={1.5} />
            </Button>
            <Button variant="outline" size="icon" onClick={nextPage} disabled={!hasNext || isRefetching} className="border-border hover:border-primary hover:text-primary hover:bg-transparent disabled:opacity-30 rounded-md" aria-label="Halaman berikutnya">
              <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
            </Button>
          </div>
        </div>}
    </>;
}
export default function NewsGrid() {
  const wp_query_params = {
    post_type: "post",
    per_page: 9,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="4629" id="news-grid" className="bg-background text-foreground pt-24 pb-32 px-4 sm:px-6 lg:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="mb-16">
          <div className="flex items-center gap-2 mb-8">
            <span className="font-mono text-xs tracking-wider text-primary">
              // BERITA_TERKINI — 47 ARTIKEL
            </span>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
            <div className="lg:col-span-7">
              <h1 className="font-default text-5xl sm:text-6xl lg:text-[6rem] leading-[0.95] tracking-tight text-foreground">
                Warta.
              </h1>
            </div>
            <div className="lg:col-span-5">
              <p className="text-base text-muted-foreground leading-relaxed font-default max-w-md">
                Informasi terbaru, kegiatan organisasi, dan klarifikasi resmi dari pengurus pusat dan daerah.
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-b border-border py-5 mb-12 -mx-4 sm:-mx-6 lg:-mx-12 px-4 sm:px-6 lg:px-12">
          <div className="flex items-center gap-2 sm:gap-3 overflow-x-auto scrollbar-hide">
            <span className="font-mono text-[10px] tracking-widest text-muted-foreground whitespace-nowrap mr-2 hidden sm:inline">
              FILTER:
            </span>
            {categories.map((cat, i) => <Button key={cat.label} data-index={i} variant={cat.active ? "default" : "outline"} size="sm" className={cat.active ? "h-8 px-4 font-mono text-[11px] tracking-wider bg-primary text-primary-foreground hover:bg-primary/90 border-0 whitespace-nowrap rounded-md" : "h-8 px-4 font-mono text-[11px] tracking-wider border-border text-muted-foreground hover:text-primary hover:border-primary bg-transparent hover:bg-transparent whitespace-nowrap rounded-md"}>
                {cat.label}
              </Button>)}
          </div>
        </div>

        <PostsProvider wp_query={{
        post_type: "post",
        per_page: 9,
        orderby: "date",
        order: "desc"
      }}>
          <JournalGrid />
        </PostsProvider>
      </div>
    </section>;
}